<template>
    <modal :modal-id="modalId"
        :title="modalTitle"
        :preloader="preloader"
        @submit="submit"
        @close-modal="closeModal">

        <template slot="body">
            <app-overlay-loader v-if="preloader"/>
            <form class="mb-0"
                  :class="{'loading-opacity': preloader}"
                  ref="form" :data-url='selectedUrl ? `master/finance-book/${inputs.id}` : `master/finance-book`'>
                  
				<div class="form-group row align-items-center">
					<label for="inputs_center_id" class="col-sm-3 mb-0">
						Center
					</label>
					<app-input
						id="inputs_center_id"
						class="col-sm-9"
						type="advance-search-select"
						:loaded-per-time="10"
						v-model="input_center_id"
						@input="setCenterIdValue"
						fetch-url="master/center"
						placeholder="Center"
						list-value-field="name"
						:required="true"
					/>
				</div>
                <div class="form-group row align-items-center">
                    <label for="inputs_code" class="col-sm-3 mb-0">
                        Code
                    </label>
                    <app-input id="inputs_code"
                               class="col-sm-9"
                               type="text"
                               v-model="inputs.code"
                               :placeholder="'Code'"
                               :required="true"/>

                </div>
                </div>
            </form>
        </template>
    </modal>
</template>

<script>
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin.js";
    import {ModalMixin} from "../../../../Mixins/ModalMixin";
    import {SCHOOL} from "../../../../Config/ApiUrl.js";

    export default {
        name: "ModalForm",
        mixins: [FormMixin, ModalMixin],
        props: {
            tableId: String,
            formId: String,
        },
        data() {
            return {
                preloader: false,
			    input_center_id: {},
                inputs: {},
                modalId: this.formId,
                modalTitle: this.$t('add'),
            }
        },
        created() {
            if (this.selectedUrl) {
                this.modalTitle = this.$t('edit');
                this.preloader = true;
            }
        },
        methods: {
            submit() {
                this.save(this.inputs);
            },
            afterSuccess(response) {
                this.$toastr.s(response.data.message);
                this.$hub.$emit('reload-' + this.tableId);
            },

            afterSuccessFromGetEditData(response) {
                this.inputs = response.data;
                
                this.input_center_id = {
                    id: response.data.center?.id,
                    code: response.data.center?.code,
                    name: response.data.center?.name,
                    is_active: response.data.center?.is_active,
                };
                this.inputs.center_id = response.data.center_id;
                this.preloader = false;
            },
            setCenterIdValue(data){
                this.inputs.center_id = this.inputs.center_id;
                if (data && data.hasOwnProperty("id")) {
                    this.inputs.center_id = data.id;
                }
            }
        },
    }
</script>
